import React from 'react';
import PropTypes from 'prop-types';
import shouldUpdate from 'utils/shouldUpdate';
import './PointValueDisplay.css';

function PointValueDisplay({
  className,
  label,
  value,
  suffix,
  enableScaling = true,
  banging = false
}) {
  const setClass = [
    'point-value-display',
    enableScaling && banging && 'growing',
    className
  ]
    .filter(c => !!c)
    .join(' ');
  return (
    <div className={setClass}>
      <div className="display-wrapper">
        {!!label && <div className="display-label">{label}</div>}
        <div className="display-value">
          {value !== undefined && value.toLocaleString()}
          {suffix}
        </div>
      </div>
    </div>
  );
}

PointValueDisplay.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number.isRequired,
  suffix: PropTypes.string,
  enableScaling: PropTypes.bool,
  banging: PropTypes.bool
};

function shouldComponentUpdate(props, nextProps) {
  return (
    props.label !== nextProps.label ||
    props.value !== nextProps.value ||
    props.banging !== nextProps.banging
  );
}

export default shouldUpdate(shouldComponentUpdate)(PointValueDisplay);
